module.exports = __webpack_public_path__ + "img/1530730550.be8fceaa.jpg";